"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.desanitize = void 0;
function desanitize(value) {
    return value.replace(/&quot;/g, '"');
}
exports.desanitize = desanitize;
//# sourceMappingURL=desanitize.js.map